<script lang="ts">
    import SettingsServiceTime from '../Settings/SettingsServiceTime.svelte';

    export let componentProps: any = {};
</script>

<SettingsServiceTime {...componentProps} />
